module.exports = __webpack_public_path__ + "static/img/3.481ba69.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/3.png
// module id = b5po
// module chunks = 0